import { createApi } from "@reduxjs/toolkit/query/react";
import axios from "axios";
import Cookies from "js-cookie";
import getTenantId from "../../components/Tenent";
import { setAccessToken, setRefreshToken } from "../slices/authSlice";
import { showAccessDeniedModal } from "../slices/authSlice";
const getStore = () => require("../store").store;

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_ACTIVITIES_HOST_URL,
  withCredentials: true,
  headers: {
    accept: `application/json`,
  },
});
const tenantId = getTenantId();

const setUpInterceptors = (getState, dispatch) => {
  axiosInstance.interceptors.request.use(
    (config) => {
      const token = getState()?.auth?.accessToken;
      const refresh_token = getState()?.auth?.refreshToken;
      if (token) {
        config.headers["Authorization"] = `Bearer ${token}`;
        config.headers["Refresh"] = `Bearer ${refresh_token}`;
      }
      return config;
    },
    (error) => Promise.reject(error)
  );
  axiosInstance.interceptors.response.use(
    (res) => res,
    async (err) => {
      const originalConfig = err.config;
      const errorMessage = err.response?.data?.error || "";

      if (
        err.response?.status === 401 &&
        errorMessage.includes("access token has expired") &&
        !originalConfig._retry
      ) {
        originalConfig._retry = true;

        const accessToken = Cookies.get('access_token')
        const refreshToken = Cookies.get('refresh_token')

        if (!refreshToken || !accessToken) {
          dispatch(setAccessToken(null));
          dispatch(setRefreshToken(null));
          return Promise.reject(err);
        }

        try {
          const parsedURL = new URL(window.location.href);
          const subdomain = parsedURL?.hostname?.split(".")?.[0];
          const tenantId = getTenantId();

          const refreshHeaders = {
            "Content-Type": "application/json",
            Authorization: `Bearer ${refreshToken}`,
            "x-tenant-id": subdomain === "localhost" ? tenantId : subdomain,
          };
          const { data } = await axios.post(
            `${process.env.REACT_APP_AUTH_API}/core/refresh`,
            {
              access_token: accessToken,
              refresh_token: refreshToken,
            },
            { headers: refreshHeaders }
          );
          dispatch(setAccessToken(data?.access_token));
          dispatch(setRefreshToken(data?.refresh_token));

          originalConfig.headers[
            "Authorization"
          ] = `Bearer ${data?.access_token}`;
          originalConfig.headers["Refresh"] = `Bearer ${data?.refresh_token}`;
          return axiosInstance(originalConfig);
        } catch (_error) {
          dispatch(setAccessToken(null));
          dispatch(setRefreshToken(null));
          return Promise.reject(_error);
        }
      }

      return Promise.reject(err);
    }
  );
};

const axiosBaseQuery =
  () =>
  async (
    { url, method, body, params, ...requestOpts },
    { getState, dispatch }
  ) => {
    setUpInterceptors(getState, dispatch);

    try {
      const axiosOptions = {
        url: url,
        method,
        data: body,
        params,
        headers: requestOpts.headers,
      };

      const result = await axiosInstance(axiosOptions);
      return { data: result.data };
    } catch (axiosError) {
      let err = axiosError;
      const errorData = axiosError.response?.data;
      const status = axiosError.response?.status;

      if (status === 403 && errorData?.error === "forbidden") {
        getStore().dispatch(showAccessDeniedModal());
      }
      return {
        error: {
          status: err.response?.status,
          data: err.response?.data || err.message,
        },
      };
    }
  };

export const Uploads3stream = createApi({
  reducerPath: "uploads3streamApi",
  baseQuery: axiosBaseQuery(),
  tagTypes: ["uploads3stream"],
  endpoints: (builder) => ({
    Uploadcustomdatastream: builder.mutation({
      query: ({ token, payload, queryParams }) => {
        const queryString = new URLSearchParams(queryParams).toString();

        console.log("payloadishere", payload);

        return {
          url: `/upload_file/?${queryString}`,
          method: "POST",
          body: payload,

          headers: {
            Authorization: `Bearer ${token}`,
            "X-Tenant-Id": tenantId,
          },
        };
      },
      invalidatesTags: ["input-items"],
    }),
  }),
});

export const { useUploadcustomdatastreamMutation } = Uploads3stream;
